import { render, staticRenderFns } from "./tc.vue?vue&type=template&id=3e1409a7&scoped=true&"
import script from "./tc.vue?vue&type=script&lang=js&"
export * from "./tc.vue?vue&type=script&lang=js&"
import style0 from "./tc.vue?vue&type=style&index=0&id=3e1409a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1409a7",
  null
  
)

export default component.exports